module.exports = __webpack_public_path__ + "static/media/29BDOS18.4d7d105a.jpg";